import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {maintenanceURL} from "../../constants/api/endpoints";
import {backendBaseUrl} from "../../constants/api/backendBaseUrl";
import {jsonToJwt} from "../../lib/jwt/jsonToJwt";

export const useGetMaintenance = () => {

  const handleRequest = async () => {
    const {data} = await axios.get(backendBaseUrl + maintenanceURL,
      {
        headers: {
          "Authorization": "Bearer " + jsonToJwt({}),
        }});
    return data;
  }

  return useQuery({
    queryKey: ['maintenance-info'],
    queryFn: handleRequest
  });
}